import React from 'react';

// Components
import { WpContainer, WpContainerBody, WpContainerHeader } from 'Wpds/components/container';
import { WpListSelect, ListSelectOption } from 'Wpds/components/list';
import CustomGPT3Attributes from 'Shared/components/CustomGPT3Attributes/CustomGPT3Attributes';
import GPT3Example from './GPT3Example';

// Styles
import './GPT3StepSelections.scss';

type Props = {
  selectedStrengths?: ListSelectOption[];
  selectedImprovements?: ListSelectOption[];
  strengthAttributeList: string[];
  strengthImprovementList: string[];
  strengthExamples: string;
  setStrengthExamples: Function;
  improvementExamples: string;
  setImprovementExamples: Function;
  onSelectStrengths?(selected: ListSelectOption[]): void;
  onSelectImprovements?(selected: ListSelectOption[]): void;
  handeAddCustomStrengthAttribute: Function;
  handeAddCustomImprovementAttribute: Function;
};

const GPT3StepSelections = ({
  selectedStrengths,
  selectedImprovements,
  strengthExamples,
  improvementExamples,
  setStrengthExamples,
  setImprovementExamples,
  strengthAttributeList,
  strengthImprovementList,
  onSelectStrengths,
  onSelectImprovements,
  handeAddCustomStrengthAttribute,
  handeAddCustomImprovementAttribute,
}: Props) => {
  const baseClassName = 'GPT3StepSelections';
  const strengthExamplesPlaceHolder = selectedStrengths.length
    ? `Examples of strengths in ${selectedStrengths.map(s => (s as any).value).join(', ')}`
    : 'Examples of strengths';
  const improvementExamplesPlaceHolder = selectedImprovements.length
    ? `Examples of opportunities for improvement in ${selectedImprovements.map(s => (s as any).value).join(', ')}`
    : 'Examples of opportunities for improvement';

  return (
    <div className={baseClassName}>
      <WpContainer className={`${baseClassName}__container`}>
        <WpContainerHeader>
          <div className={`${baseClassName}__container__title`}>Strengths (select up to 2)</div>
        </WpContainerHeader>
        <WpContainerBody>
          <p>Select strengths you want to give feedback on.</p>
          <div>
            <WpListSelect
              id="options-strengths"
              options={strengthAttributeList}
              direction="horizontal"
              onChange={onSelectStrengths}
              max={2}
              selectedOptions={selectedStrengths}
              qaTest="strength-select-list"
            />
          </div>
          <CustomGPT3Attributes
            inputId="custom-strength-attribute-input"
            label="Add custom strength"
            handleAddCustomAttribute={handeAddCustomStrengthAttribute}
            placeholder="Area of strength"
          />
          <GPT3Example
            label="Add example"
            inputId="strength-examples-input"
            value={strengthExamples}
            setValue={setStrengthExamples}
            placeholder={strengthExamplesPlaceHolder}
          />
        </WpContainerBody>
      </WpContainer>
      <WpContainer className={`${baseClassName}__container`}>
        <WpContainerHeader>
          <div className={`${baseClassName}__container__title`}>Opportunities for improvement (select up to 2)</div>
        </WpContainerHeader>
        <WpContainerBody>
          <p>Select opportunities for improvement you want to give feedback on.</p>
          <div>
            <WpListSelect
              id="options-improvements"
              options={strengthImprovementList}
              direction="horizontal"
              onChange={onSelectImprovements}
              selectedOptions={selectedImprovements}
              max={2}
              qaTest="improvements-select-list"
            />
          </div>
          <CustomGPT3Attributes
            inputId="custom-improvements-attribute-input"
            label="Add custom improvement"
            handleAddCustomAttribute={handeAddCustomImprovementAttribute}
            placeholder="Area of improvement"
          />
          <GPT3Example
            inputId="improvement-examples-input"
            label="Add example"
            value={improvementExamples}
            setValue={setImprovementExamples}
            placeholder={improvementExamplesPlaceHolder}
          />
        </WpContainerBody>
      </WpContainer>
    </div>
  );
};

export default GPT3StepSelections;
